import React from 'react';
import { Box, ListItem, ListItemText, Typography } from '@material-ui/core';
import { NotificationsActive } from '@material-ui/icons';
import { unpackToDateTime } from '@campfire/hot-date';

export interface ApplicationReminderCommunication {
  __typename: 'VOLUNTEER_ApplicationReminderType';
  applicationReminderId: string;
  sentAt: any;
  subject: string;
  tasks: Array<{ taskId: string; title: string }>;
}

export const toReminderCommunication = (reminder: {
  applicationReminderId: string;
  remindedAt: any;
  tasks: Array<{ taskId: string; title: string }>;
}): ApplicationReminderCommunication => ({
  __typename: 'VOLUNTEER_ApplicationReminderType',
  applicationReminderId: reminder.applicationReminderId,
  sentAt: reminder.remindedAt,
  subject: 'Onboarding reminder',
  tasks: reminder.tasks,
});

export const ApplicationReminderListItem = ({ reminder }: { reminder: ApplicationReminderCommunication }) => (
  <Box display='flex' justifyContent='flex-between'>
    <Box mt='28px' width='85px' position='relative'>
      <Box
        style={{
          display: 'flex',
          backgroundColor: '#FFB300',
          borderRadius: '3px',
          padding: '4px 8px',
          alignItems: 'center',
          position: 'absolute',
          right: 0,
        }}
      >
        <NotificationsActive style={{ fontSize: '11px', color: '#FCFCFC', marginRight: '4px' }} />
        <Typography style={{ fontWeight: 600, fontSize: '11px', color: '#FCFCFC' }}>Sent</Typography>
      </Box>
    </Box>
    <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <ListItemText
        primary={
          <Typography variant='h6' style={{ fontWeight: 900, fontSize: '14px', color: '#444444' }}>
            {reminder.subject}
          </Typography>
        }
        secondary={
          <Typography style={{ fontSize: '10px', color: '#9E9E9E', fontStyle: 'italic' }}>
            {reminder.sentAt && `Sent ${unpackToDateTime(reminder.sentAt).toFormat('h:mm a, dd LLLL yyyy')}`}
          </Typography>
        }
      />
      <Box display='flex' flexWrap='wrap' style={{ gap: '10px' }}>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#d9d9d9',
            borderRadius: '3px',
            padding: '4px 8px',
          }}
        >
          <NotificationsActive style={{ fontSize: '11px', color: '#545454', marginRight: '4px' }} />
          <Typography style={{ fontWeight: 600, fontSize: '10px', color: '#545454' }}>Reminder</Typography>
        </Box>
        {reminder.tasks.map((task) => (
          <Box key={task.taskId} style={{ border: '1px solid #d9d9d9', borderRadius: '3px', padding: '4px 8px' }}>
            <Typography style={{ fontWeight: 600, fontSize: '10px', color: '#545454' }}>{task.title}</Typography>
          </Box>
        ))}
      </Box>
    </ListItem>
  </Box>
);
